import { useLayoutEffect, useRef, useState } from 'react';

// Lines the page's tools (Visning/Fokus) up with the right edge of the list's frame: measured from the page header and the
// frame itself, so it stays exact when the side panel is dragged or the window resized. Returns the ref for the page element
// and the CSS variable to put on its style (read by .pg-tools / .cfg2__tools in StatusCards.css).
export function useToolsAlign() {
  const ref = useRef(null);
  const [right, setRight] = useState(null);
  useLayoutEffect(() => {
    const page = ref.current;
    if (!page) return undefined;
    const measure = () => {
      const head = page.querySelector('.head');
      const card = page.querySelector('.wq-menu__card');
      if (!head || !card) return;
      const v = Math.round(head.getBoundingClientRect().right - card.getBoundingClientRect().right);
      setRight((prev) => (prev === v ? prev : v));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  });
  return [ref, right != null ? { '--tools-right': `${right}px` } : {}];
}
